"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_createTransaction_1 = __importDefault(require("../js-createTransaction"));
const js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
const js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
const js_prepareTransaction_1 = __importDefault(require("../js-prepareTransaction"));
const js_signOperation_1 = __importDefault(require("../js-signOperation"));
const js_synchronisation_1 = require("../js-synchronisation");
const js_updateTransaction_1 = __importDefault(require("../js-updateTransaction"));
const jsHelpers_1 = require("../../../bridge/jsHelpers");
const preloadedData_1 = require("../preloadedData");
const Cosmos_1 = require("../api/Cosmos");
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const CosmosValidatorsManager_1 = require("../CosmosValidatorsManager");
const serialization_1 = require("../serialization");
const config_1 = require("../../../config");
const chain_1 = __importDefault(require("../chain/chain"));
const receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
const getPreloadStrategy = _currency => ({
    preloadMaxAge: 30 * 1000,
});
const currencyBridge = {
    getPreloadStrategy,
    preload: (currency) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield (0, config_1.getCurrencyConfiguration)(currency);
        const cosmosValidatorsManager = new CosmosValidatorsManager_1.CosmosValidatorsManager((0, cryptoassets_1.getCryptoCurrencyById)(currency.id), { endPoint: config.lcd });
        const validators = yield cosmosValidatorsManager.getValidators();
        (0, preloadedData_1.setCosmosPreloadData)(currency.id, {
            validators,
        });
        return Promise.resolve({
            validators,
            config,
        });
    }),
    hydrate: (data, currency) => {
        if (!data || typeof data !== "object")
            return;
        const { validators } = data;
        if (!validators || typeof validators !== "object" || !Array.isArray(validators))
            return;
        const relatedImpl = (0, chain_1.default)(currency.id);
        relatedImpl.lcd = data.config.lcd;
        relatedImpl.minGasPrice = data.config.minGasPrice;
        relatedImpl.ledgerValidator = data.config.ledgerValidator;
        const cosmosValidatorsManager = new CosmosValidatorsManager_1.CosmosValidatorsManager((0, cryptoassets_1.getCryptoCurrencyById)(currency.id));
        cosmosValidatorsManager.hydrateValidators(validators);
        (0, preloadedData_1.setCosmosPreloadData)(currency.id, (0, preloadedData_1.asSafeCosmosPreloadData)(data));
    },
    scanAccounts: js_synchronisation_1.scanAccounts,
};
const accountBridge = {
    createTransaction: js_createTransaction_1.default,
    updateTransaction: js_updateTransaction_1.default,
    prepareTransaction: js_prepareTransaction_1.default,
    estimateMaxSpendable: js_estimateMaxSpendable_1.default,
    getTransactionStatus: js_getTransactionStatus_1.default,
    sync: js_synchronisation_1.sync,
    receive,
    signOperation: js_signOperation_1.default,
    assignFromAccountRaw: serialization_1.assignFromAccountRaw,
    assignToAccountRaw: serialization_1.assignToAccountRaw,
    broadcast: ({ account, signedOperation }) => __awaiter(void 0, void 0, void 0, function* () {
        return new Cosmos_1.CosmosAPI(account.currency.id).broadcast({
            signedOperation,
        });
    }),
};
exports.default = {
    currencyBridge,
    accountBridge,
};
//# sourceMappingURL=js.js.map